/**
 * POST `admin/clients/:id/ledger/entries` — ручная операция по счёту.
 *
 * Нужна там, где автоматики нет: клиника перевела по счёту на
 * расчётник, мы договорились о скидке, списали лишнее. Бэк требует
 * комментарий (3–500 символов) — и правильно: через месяц «+30 000»
 * без пояснения не отличить от ошибки.
 *
 * Сумма — целые тыйыны, строго больше нуля. Направление задаёт `kind`,
 * а не знак: минуса в поле не бывает, «списать» — это `debit`.
 */

import {http} from '@services/utils';

import {toLedgerEntry} from '../toLedger';
import type {LedgerEntry, LedgerEntryInput} from '../types';

export const addLedgerEntry = async ({
  clinicId,
  kind,
  amountTiyin,
  comment,
}: LedgerEntryInput): Promise<LedgerEntry> => {
  const raw = await http(`admin/clients/${encodeURIComponent(clinicId)}/ledger/entries`, {
    method: 'POST',
    body: {kind, amountTiyin, comment},
    skipCaseConversion: true,
  });
  return toLedgerEntry(raw);
};
